import { Component, HostListener, OnInit } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { AppSettingsModel, Asset } from 'src/app/Modelo/AppSettings.Model';
import { SettingsService } from 'src/app/servicios/settings.service';

@Component({
  selector: 'app-swiper-brand',
  templateUrl: './swiper-brand.component.html',
  styleUrls: ['./swiper-brand.component.scss']
})
export class SwiperBrandComponent implements OnInit {
  private _appSettings: AppSettingsModel;
  public ConfiguracionSlider: SwiperOptions;

  get brands(): Array<Asset> {
    return this._appSettings?.swiperBrands?.filter(b => b.visible) ?? new Array<Asset>();
  }

  constructor(private _appSettingsService: SettingsService) { }

  ngOnInit(): void {
    this.setOptions();
    this._appSettingsService.get().then((appSettings: AppSettingsModel) => this._appSettings = appSettings);
   }

  setOptions() {
    this.ConfiguracionSlider = {
      init: true,
      speed: 500,
      slidesPerView: 2,
      spaceBetween: 2,
      loop: true,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
        waitForTransition: true
      },
      breakpoints: {
        // when window width is >= 450px
        450: {
          slidesPerView: 3,
        },
        // when window width is >= 650px
        650: {
          slidesPerView: 5,
        },
        880: {
          slidesPerView: 6,
        }
      },
      navigation: {
        nextEl: "#button-brand-next",
        prevEl: "#button-brand-prev",
      } 
    };
  }
}
